import { NavLink } from "react-router-dom";

const Navigation = () => {
  const navList = [
    { id: 1, path: "/", title: "Home" },
    { id: 2, path: "/aboutus", title: "About Us" },
    // { id: 3, path: "/service", title: "Services" },
    // { id: 4, path: "/prices", title: "Prices" },
    { id: 5, path: "/helpdesk", title: "FAQ" },
    { id: 6, path: "/contact", title: "Contacts" },
  ];

  return (
    <nav id="tt-nav">
      <ul>
        {navList.map((nav) => (
          <li key={nav.id}>
            <NavLink
              to={nav.path}
              className={({ isActive }) =>
                `block font-medium transition duration-300 ${
                  isActive ? "text-purple-700 font-bold" : "text-black"
                }`
              }
            >
              {nav.title}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

const Navbar = () => {
  return (
    <header id="tt-header">
      <div id="js-init-sticky">
        <div className="tt-holder-wrapper">
          <div className="tt-holder">
            <div className="tt-col-left">
              <a href="index.html" className="tt-logo tt-logo-alignment">
                {/* <i className="icons-logo tt-icon"></i> */}
                <span className="tt-base-color">Sp</span>pinzy
              </a>
            </div>
            <div className="tt-col-center tt-col-wide tt-col-objects text-center">
              <div className="tt-col__item">
                <Navigation />
              </div>
            </div>
            <div className="tt-col-right tt-col-objects">
              <div className="tt-col__item d-block d-lg-none">
                <div className="h-info02">
                  <div className="tt-item">
                    <address>
                      <a href="tel:1(800)7654321">
                        <span className="icons-483947"></span> 1 (800) 765-43-21
                      </a>
                    </address>
                  </div>
                </div>
              </div>
              {/* <div className="tt-col__item">
                <div className="tt-obj tt-obj-cart js-dropdown-cart">
                  <a href="#" className="tt-obj__btn">
                    <div className="tt-obj__badge">2</div>
                  </a>
                </div>
              </div> */}
              {/* <div className="tt-col__item d-none d-md-block">
                <a
                  href="#"
                  className="tt-btn"
                  data-toggle="modal"
                  data-target="#modalMRequestQuote"
                >
                  <span className="mask">Schedule a Pickup</span>
                  <div className="button">Schedule a Pickup</div>
                </a>
              </div> */}
              <div className="tt-col__item toggle-wrapper">
                <a href="#" id="tt-menu-toggle" className="icons-1828859"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
